import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CampaignMediaService } from 'src/app/services/campaign-media.service';

@Component({
    selector: 'app-pause-campaign-visual-modal',
    templateUrl: './pause-campaign-visual-modal.component.html',
    styleUrls: ['./pause-campaign-visual-modal.component.scss']
})
export class PauseCampaignVisualModalComponent {
    subMedia: any;
    pausing = false;

    constructor(
        public dialogRef: MatDialogRef<PauseCampaignVisualModalComponent>,
        private campaignMediaService: CampaignMediaService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.subMedia = this.data.subMedia;
    }

    getTitle() {
        return this.data.title;
    }

    // Closes with true once the visual is paused, so step 4 reloads the campaign and shows it.
    pauseCampaignVisual() {
        this.pausing = true;
        this.campaignMediaService
            .pauseCampaignVisual(this.data.campaignId, this.subMedia.id)
            .subscribe(
                _ => this.dialogRef.close(true),
                _ => this.pausing = false
            );
    }
}
